// hooks/useSubscriptionCheck.js
import { useState, useEffect } from "react";

export const useSubscriptionCheck = () => {
  const [premiumStatus, setPremiumStatus] = useState("");
  const [showDialog, setShowDialog] = useState(false);

  const checkSubscriptionStatus = async (shown = true) => {
    try {
      // Replace with your actual storage helper
      const subscriptionStatus = localStorage.getItem(
        "premium_subscription_status",
      );
      const status = subscriptionStatus || "";

      setPremiumStatus(status);

      if (subscriptionStatus !== "true") {
        shown ? setShowDialog(true) : setShowDialog(false);
        return false;
      }
      return true;
    } catch (error) {
      console.error("Error checking subscription:", error);
      return false;
    }
  };

  return {
    premiumStatus,
    showDialog,
    setShowDialog,
    checkSubscriptionStatus,
  };
};
